import { Outlet, useLoaderData } from '@tanstack/react-router';
import { useEffect } from 'react';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { MarketplaceHeader, MarketplaceTabs } from '@anytag/shared-organisms';
import { MarketplaceRouter } from '../../../app/_private-routes/marketplace';
import { MarketplaceDetailsProvider } from './marketplace-details-context';

export const MarketplaceDetails = () => {
  const { t, enqueueSnackbar, navigate } = useQueryHelper();
  const { loading, errorMessage, marketplace, networkStatus } = useLoaderData({
    from: '/_private-routes/marketplace/$id'
  }) as Awaited<ReturnType<(typeof MarketplaceRouter)['/_private-routes/marketplace/$id']['1']['loader']>>;

  useEffect(() => {
    if (errorMessage) {
      enqueueSnackbar(t(errorMessage), { variant: 'error' });
      navigate({ to: '/marketplace' });
    }
  }, [errorMessage]);

  return (
    <RenderDataWithFallback loading={loading && networkStatus === 1}>
      {marketplace ? (
        <MarketplaceDetailsProvider value={{ marketplace }}>
          <MarketplaceHeader marketplace={marketplace} />

          <MarketplaceTabs marketplace={marketplace} />
          <Outlet />
        </MarketplaceDetailsProvider>
      ) : null}
    </RenderDataWithFallback>
  );
};
